
export const listFilter = [
    {
        field: 'search',
        title: 'Từ khóa',
        type: 'string',
        value: '',
        component: '',
        sort: 0
    }    
]